export default __webpack_public_path__ + "static/media/user.109eb920.png";